import { safeEncodeUrl } from '../../utility/primitiveManipulation.js';
import { isSkimlinksWrapperConfig } from '../typeGuards/index.js';
import { SKIMLINKS_WRAP_HOST } from './constants.js';
export default function skimlinksLinkWrapper(linkUrl, config) {
    if (!isSkimlinksWrapperConfig(config)) {
        return linkUrl;
    }
    if (config.params?.publisherId === undefined || config.params.publisherId === '') {
        return linkUrl;
    }
    if (linkUrl.includes(SKIMLINKS_WRAP_HOST)) {
        // do not wrap something that already includes the host.
        // we are not checking the exact host of the url, as the trackonomics wrap
        // may itself have been wrapped
        return linkUrl;
    }
    return `https://${SKIMLINKS_WRAP_HOST}/?id=${config.params.publisherId}&url=${safeEncodeUrl(linkUrl)}`;
}
//# sourceMappingURL=skimlinksLinkWrapper.js.map